import { GTextField } from "./GTextField";
import { GTextInput } from "./GTextInput";
import { GWidget } from "./GWidget";
import { WidgetRef } from "./WidgetRef";
export class GLabel extends GWidget {
    get title() {
        if (this._titleWidget)
            return this._titleWidget.p.text;
        else
            return "";
    }
    set title(value) {
        if (this._titleWidget)
            this._titleWidget.p.text = value;
    }
    get text() {
        return this.title;
    }
    set text(value) {
        this.title = value;
    }
    get icon() {
        if (this._iconWidget)
            return this._iconWidget.p.icon;
        else
            return "";
    }
    set icon(value) {
        if (this._iconWidget)
            this._iconWidget.p.icon = value;
    }
    get titleColor() {
        let tf = this.findTextWidget();
        if (tf)
            return tf.color;
        else
            return "#000000";
    }
    set titleColor(value) {
        let tf = this.findTextWidget();
        if (tf)
            tf.color = value;
    }
    get titleFontSize() {
        let tf = this.findTextWidget();
        if (tf)
            return tf.fontSize;
        else
            return 0;
    }
    set titleFontSize(value) {
        let tf = this.findTextWidget();
        if (tf)
            tf.fontSize = value;
    }
    get titleWidget() {
        var _a;
        return ((_a = this._titleWidget) === null || _a === void 0 ? void 0 : _a.p) || null;
    }
    set titleWidget(val) {
        this._titleWidget = WidgetRef.create(this._titleWidget, val, () => this._onPartChanged("title"));
        this._onPartChanged("title");
    }
    get iconWidget() {
        var _a;
        return ((_a = this._iconWidget) === null || _a === void 0 ? void 0 : _a.p) || null;
    }
    set iconWidget(val) {
        this._iconWidget = WidgetRef.create(this._iconWidget, val, () => this._onPartChanged("icon"));
        this._onPartChanged("icon");
    }
    _onPartChanged(which) {
    }
    findTextWidget() {
        let p = this._titleWidget;
        while (p) {
            let pp = p.p;
            if ((pp instanceof GTextField) || (pp instanceof GTextInput))
                return pp;
            if (pp instanceof GLabel)
                p = pp._titleWidget;
            else
                break;
        }
        return null;
    }
}
